import { Component, EventEmitter, HostBinding, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { KeyValue } from '@angular/common';
import {AzIcon} from '@azigrene/components/lib/basic/icon/heroicons';

export interface IStep {
  title: string;
  icon?: AzIcon;
  canGoBack: boolean;
  canBeClicked?: boolean;
  click?: () => void;
  condition?: () => boolean;
  disabled: boolean;
  previous: number;
  next: number;
  active?: boolean;
  nextStepText?: string;
  previousStepText?: string;
  nextEnabled?: () => boolean;
  previousEnabled?: () => boolean;
}

export interface ISteps {
  [id: string]: IStep;
}

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {

  @HostBinding('class') class = 'flex flex-col h-full w-full overflow-y-hidden';

  @Input() activeStep: string;
  @Input() steps: ISteps = {};
  stepsKeys: string[];
  @Input() showFooter = true;
  @Input() showHeader = true;
  @Input() headerTitle: string;
  @Input() headerSubtitle: string;
  @Input() nextStepText = 'Siguiente';
  @Input() previousStepText = 'Anterior';

  @Output() nextStep = new EventEmitter<{ from: string, to: string }>();
  @Output() previousStep = new EventEmitter<{ from: string, to: string }>();
  @Output() lastStep = new EventEmitter();

  @Input() contentTemplate: TemplateRef<any>;
  @Input() buttonTemplate: TemplateRef<any>;

  activeStepIndex: number = 0;
  previousEnabled = true;
  nextEnabled = true;

  originalOrder = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => {
    return 0;
  };

  ngOnInit(): void {
    this.stepsKeys = [];
    for (const key in this.steps) {
      this.stepsKeys.push(key);
    }
    this.saveActiveStepIndex();
  }

  isLastStep(): boolean {
    return this.activeStep === this.availableSteps[this.stepsKeys.length - 1];
  }


  isFirstStep(): boolean {
    return this.activeStep === this.availableSteps[0];
  }

  getNextStep(): string {
    return this.availableSteps[this.availableSteps.indexOf(this.activeStep) + 1];
  }

  calculateEnabledButtons(): void {
    if (this.isFirstStep()) {
      this.previousEnabled = false;
    }

    if (this.isLastStep()) {
      this.nextEnabled = false;
    }
  }

  private get availableSteps(): string[] {
    return Object.entries(this.steps).filter((k, i) => {
      return !k[1].disabled;
    }).map((value, index) => {
      return value[0];
    });
  }

  getPreviousStep(): string {
    return this.availableSteps[this.availableSteps.indexOf(this.activeStep) - 1];
  }

  onPreviousStep(): void {
    if (!this.isFirstStep()) {
      const previous = this.activeStep;

      this.activeStep = this.getPreviousStep();
      this.previousStep.emit({ from: previous, to: this.activeStep });
    }

    this.saveActiveStepIndex();
    this.calculateEnabledButtons();
  }

  onNextStep(): void {
    if (this.isLastStep()) {
      this.lastStep.emit(true);
    } else {
      const previousStep = JSON.parse(JSON.stringify(this.activeStep));

      this.activeStep = this.getNextStep();
      this.nextStep.emit({ from: previousStep, to: this.activeStep });
    }

    this.saveActiveStepIndex();
    this.calculateEnabledButtons();
  }

  hideStep(step: string): void {
    this.steps[step].disabled = true;
  }

  saveActiveStepIndex() : void{
    this.activeStepIndex = this.stepsKeys.indexOf(this.activeStep);
  }


}
